import { BlockTextField } from '../../ConfigFields/TextField';

export function GetExternalDocumentPacketFormFields() {
  return (
    <BlockTextField
      fieldName="config.externalDocumentPacketId"
      label="Test externalDocumentPacketId (leave empty to use provided entity)"
      helperText="Extract an External Document Packet using the externalDocumentPacketId."
    />
  );
}
